import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
export function WatchSeason2Section() {
  return <section className="relative w-full py-24 bg-black overflow-hidden" data-id="element-186">
      {/* Background Image - Updated with new bgVideoMobile.jpg */}
      <div className="absolute inset-0 z-0 opacity-50" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/rukTu6uFryU7rhaAKj4So4/bgVideoMobile.jpg')",
      backgroundSize: 'cover',
      backgroundPosition: 'center top'
    }} data-id="element-187" />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 z-1 bg-gradient-to-t from-black via-black/70 to-black/40" data-id="element-188" />

      <div className="relative z-10 max-w-7xl mx-auto px-6" data-id="element-189">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-190">
          {/* Video Embed */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full lg:w-3/5 aspect-video rounded-2xl overflow-hidden shadow-2xl shadow-[#00A8E1]/20 border border-white/10" data-id="element-191">
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/SI3CrHUAGqM?si=beastgames" title="Beast Games Season 2 Trailer" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="w-full h-full" data-id="element-192"></iframe>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-2/5 text-center lg:text-left" data-id="element-193">
            <div className="inline-flex items-center space-x-2 bg-[#00A8E1]/10 px-4 py-2 rounded-full border border-[#00A8E1]/30 mb-6" data-id="element-194">
              <span className="w-2 h-2 bg-[#00A8E1] rounded-full animate-pulse" data-id="element-195" />
              <span className="text-[#00A8E1] font-bold tracking-widest uppercase text-xs" data-id="element-196">
                Streaming Now
              </span>
            </div>

            <h2 className="font-oswald text-5xl md:text-7xl font-bold text-white uppercase leading-none mb-6" data-id="element-197">
              Season <span className="text-[#00A8E1]" data-id="element-198">2</span>
            </h2>

            <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-199">
              The competition gets bigger, harder, and more intense. Do you have
              what it takes to win the biggest prize in television history?
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-200">
              <a href="https://www.amazon.com/gp/video/detail/B0G2RVNJMC/ref=atv_dp_season_select_s2" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 font-bold text-black transition-all duration-200 bg-[#ffd700] font-oswald text-xl uppercase tracking-widest hover:bg-white hover:scale-105 rounded-lg" data-id="element-201">
                <Play className="w-5 h-5 mr-2 fill-current" data-id="element-202" />
                Watch Trailer
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}